import classNames from 'classnames'
import sanitize from 'sanitize-html'

import { Translation } from 'cng-common/features/translations/components/translation'
import { IForm } from 'core-components/classes/models/IForm'

import styles from './SimpleField.module.scss'

interface IProps {
  className?: string
  htmlClassName?: string
  item: IForm
  field: string
  value?: string
  label?: string
  translate?: boolean
}

export const HtmlField = ({
  className,
  htmlClassName = '',
  item,
  field,
  value,
  label,
  translate,
}: IProps) => {
  return (
    <div className={classNames(styles.root, className || '')}>
      {label && (
        <p className={styles.label}>
          {translate ? <Translation text={label} span actionsInside /> : label}:
        </p>
      )}
      <div
        className={classNames(styles.html, htmlClassName)}
        dangerouslySetInnerHTML={{ __html: sanitize(value ? value : item[field]) }}
      />
    </div>
  )
}
